import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-controls", "autoComplete", "Input", "__hideSearch"];
import { forwardRef, memo } from 'react';
import { SearchInput } from '../SearchInput';
import styled from 'foundations-theming/utils';
import ShareInput from '../ShareInput/ShareInput';
import { useDropdownContext } from '../Dropdown/DropdownContext';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { getScreenReaderOnlyStyles } from '../../utils/styles/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTypeaheadSearch = styled.div.withConfig({
  displayName: "TypeaheadSearch__StyledTypeaheadSearch"
})(({
  theme,
  $cssStyles,
  $srOnly
}) => {
  return Object.assign({
    backgroundColor: theme.color['fill-surface-recessed'],
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: theme.space['300'],
    position: 'relative',
    input: {
      paddingInlineEnd: theme.space['800'],
      backgroundColor: theme.color['fill-surface-default']
    }
  }, $srOnly && Object.assign({}, getScreenReaderOnlyStyles(theme)), $cssStyles);
});
const TypeaheadSearchComponent = (_ref, ref) => {
  let {
      'aria-controls': ariaControls = 'off',
      autoComplete = 'off',
      Input = SearchInput,
      __hideSearch = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isDropdown
  } = useDropdownContext();
  const {
    tokenProps,
    domProps,
    callbackProps,
    restProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledTypeaheadSearch, {
    $cssStyles: cssStyles,
    $srOnly: __hideSearch,
    children: /*#__PURE__*/_jsx(Input, Object.assign({
      autoFocus: isDropdown,
      "aria-autocomplete": "list",
      "aria-controls": ariaControls,
      autoComplete: autoComplete,
      inputRef: ref,
      type: "search"
    }, domProps, callbackProps, restProps))
  });
};
export const TypeaheadSearch = ShareInput( /*#__PURE__*/memo( /*#__PURE__*/forwardRef(TypeaheadSearchComponent)));
TypeaheadSearch.displayName = 'TypeaheadSearch';